<div class="row">
    <div class="col">
        <p class="total-data">Total: {{data.length}} resultados </p>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="form-group">
            <input [(ngModel)]="search" (ngModelChange)="onSearch()" type="text" class="form-control" id=""
                placeholder="Buscar">
        </div>
    </div>
</div>
<div class="row row-infiniteScroll" infiniteScroll #scrollTwo [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
    [scrollWindow]="false" (scrolled)="onModalScrollDown()">
    <div class="col-md-4 p-1" *ngFor="let result of dataSlice">
        <div class="card">
            <div class="card-body">
                <div class="container-image d-flex justify-content-center align-items-center">
                    <a [routerLink]="['/', tenantSlug, result.idEncriptado]" target="_blank"
                       (mousedown)="campaignService.getParam(datas)" class="btn btn-link">
                        <img [src]="result.fotoExists ? result.fotoTemp : 'assets/img/noimage.png'" alt="...">
                    </a>
                </div>
                <hr style="margin: 15px -20px;">
                <h5 *ngIf="ylabel!=2" class="card-title">
                    <a [routerLink]="['/', tenantSlug, result.idEncriptado]" target="_blank"
                       (mousedown)="campaignService.getParam(datas)" class="btn btn-secondary btn-sm text-white">{{result.PlanMedio}}</a>
                </h5>
                <h5 *ngIf="ylabel==2" class="card-title">
                    <a [routerLink]="['/', tenantSlug, result.idEncriptado]" target="_blank"
                       (mousedown)="campaignService.getParam(datas)" class="btn btn-secondary btn-sm text-white">{{result.voceros}}</a>
                </h5>
                <div *ngIf="xlabel==1" class="d-flex flex-wrap">
                    <p class="card-text my-0 mr-2"><small class="text-muted">Plataforma:</small></p>
                    <p class="card-text my-0 mr-2">
                        <span class="badge" [ngStyle]="getPlatformStyle(result.idPlataforma)">{{result.Plataforma}}</span>
                    </p>
                </div>
                <div class="d-flex flex-wrap" *ngIf="xlabel==2">
                    <p class="card-text my-0 mr-2"><small class="text-muted">Tipo de Nota:</small></p>
                    <p class="card-text my-0 mr-2">
                        <span class="badge" [ngStyle]="getTypeNoteStyle(result.tipoNota)">{{result.note}}</span>
                    </p>
                </div>

                <div *ngIf="xlabel==3 && result.tipoTier" class="d-flex flex-wrap">
                    <p class="card-text my-0 mr-2"><small class="text-muted">Tier:</small></p>
                    <p class="card-text my-0 mr-2">
                        <span class="badge" [ngStyle]="getTierStyle(result.tipoTier)">{{result.tierName}}</span>
                    </p>
                </div>
                <div class="d-flex flex-wrap">
                    <p class="card-text my-0 mr-2">
                        <small class="text-muted">
                            Fecha Publicación: {{result.fechaPublicacion | date:'dd/MM/yyyy'}}
                        </small>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>